import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import CompetitorLogo from '@/features/sports/components/ui/CompetitorLogo.vue';
import { SingleStepSportEvent, SportEventStatus } from '@/@types/graphql-types';
import { EventsEdgeContext, SingleStepContext, contextIs } from '@/features/sports/helpers/config';
import { useLanguageStore } from '@/helpers/composables/useStores';


export default /*#__PURE__*/_defineComponent({
  __name: 'SingleStepEventCard',
  props: {
    event: null,
    expandOffers: { type: Boolean },
    context: null
  },
  setup(__props: any) {

const props = __props as {
	event: SingleStepSportEvent;
	expandOffers: boolean;
	context: SingleStepContext | EventsEdgeContext;
};



const { webLocale } = useLanguageStore();

const node = computed(() => {
	return props.event ?? {};
});

const fullPath = computed(() => {
	return node.value.content.fullPath;
});

const competitors = computed(() => {
	if (!contextIs.event(props.context)) {
		return props.context.getCompetitors(node.value, webLocale.value);
	}

	throw Error(`[SingleStepEventCard] does not support page type: ${props.context.pageType}`);
});

const startName = computed(() => {
	return competitors.value.start.map(team => team.name).join(' / ');
});

const startCompetitor = computed(() => {
	return competitors.value.start[0];
});

const endName = computed(() => {
	return competitors.value.end.map(team => team.name).join(' / ');
});

const endCompetitor = computed(() => {
	return competitors.value.end[0];
});

const startDateTime = computed(() => {
	return new Date(props.event.content.startAt) ?? null;
});

const isEnded = computed(() => {
	return props.event.content?.status === SportEventStatus.Closed;
});

return { __sfc: true,props, webLocale, node, fullPath, competitors, startName, startCompetitor, endName, endCompetitor, startDateTime, isEnded, CompetitorLogo }
}

})